/**
 * Default values and settings for items
 */
 const ItemSetting = {
  DEFAULT_MAX_AMOUNT: 100
}

export default ItemSetting
